import React, { useState, useEffect } from 'react'
import '../styles.less'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SumamaryProposalFilterWidget from '../../../widgets/sumamaryProposalFilter/SumamaryProposalFilterWidget'
import SumamaryProposalFilterFeedBack from '../../../widgets/sumamaryProposalFilter/SumamaryProposalFilterFeedBack'

export default function SumamaryProposalFilter() {
  const [isEditWidget, setIsEditWidget] = useState({})
  // const [isEditAll, setIsEditAll] = useState(false)
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [summaryBudget, setSummaryBudget] = useState()
  const [showEditAll, setShowEditAll] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        <ProjectBasicInfo schema={schema.projectInfo} />
        <br />
        <SumamaryProposalFilterWidget schema={schema?.from?.sumamaryProposalFilter} />
        <br />
        <SumamaryProposalFilterFeedBack schema={schema?.from?.feedBack} />
      </SidebarProposal>
    </>
  )
}
